const actions = { WAITLIST: 'waitlist', REGISTER: 'register' };

export default actions;
